import { Employee, ExportFilterEmployee } from '@/lib/employee/Employee.types'
import {
  columnFacetingFeature,
  columnFilteringFeature,
  columnVisibilityFeature,
  constructFilterFn,
  createFacetedMinMaxValues,
  createFacetedRowModel,
  createFacetedUniqueValues,
  createFilteredRowModel,
  createPaginatedRowModel,
  createSortedRowModel,
  globalFilteringFeature,
  metaHelper,
  rowPaginationFeature,
  rowSelectionFeature,
  rowSortingFeature,
  tableFeatures,
} from '@tanstack/react-table'
import type {
  CellContext,
  CellData,
  Column,
  ColumnDef,
  HeaderContext,
  ReactTable,
  RowData,
} from '@tanstack/react-table'
import { rankItem } from '@tanstack/match-sorter-utils'
import type { RankingInfo } from '@tanstack/match-sorter-utils'
import {
  PaymentMethod,
  ExportFilterPaymentMethod,
} from '@/lib/paymentmethod/PaymentMethod'
import {
  PaymentHistory,
  ExportFilterPaymentHistory,
} from '@/lib/paymenthistory/PaymentHistory'

export type TableDataType = Employee | PaymentMethod | PaymentHistory

export type FuzzyFilterMeta = {
  itemRank: RankingInfo
}

export const fuzzyFilter = constructFilterFn({
  filter: (dataValue, filterValue, _row, _columnId, addMeta) => {
    const itemRank = rankItem(dataValue, String(filterValue))

    addMeta?.({
      itemRank,
    })

    return itemRank.passed
  },
})

export const tableWrapperFeatures = tableFeatures({
  columnFilteringFeature,
  globalFilteringFeature,
  rowSortingFeature,
  rowPaginationFeature,
  rowSelectionFeature,
  columnVisibilityFeature,
  columnFacetingFeature,
  filteredRowModel: createFilteredRowModel(),
  sortedRowModel: createSortedRowModel(),
  paginatedRowModel: createPaginatedRowModel(),
  facetedRowModel: createFacetedRowModel(),
  facetedUniqueValues: createFacetedUniqueValues(),
  facetedMinMaxValues: createFacetedMinMaxValues(),
  filterFns: {
    fuzzy: fuzzyFilter,
  },
  filterMeta: metaHelper<FuzzyFilterMeta>(),
})

export type TableWrapperFeatures = typeof tableWrapperFeatures
export type TableWrapperColumnDef<
  TData extends RowData,
  TValue = CellData,
> = ColumnDef<TableWrapperFeatures, TData, TValue>
export type TableWrapperTable<TData extends RowData> = ReactTable<
  TableWrapperFeatures,
  TData
>
export type TableWrapperColumn<
  TData extends RowData,
  TValue = unknown,
> = Column<TableWrapperFeatures, TData, TValue>
export type TableWrapperHeaderContext<
  TData extends RowData,
  TValue = unknown,
> = HeaderContext<TableWrapperFeatures, TData, TValue>
export type TableWrapperCellContext<
  TData extends RowData,
  TValue = unknown,
> = CellContext<TableWrapperFeatures, TData, TValue>

export type ExportFilter =
  ExportFilterEmployee | ExportFilterPaymentMethod | ExportFilterPaymentHistory

//export type PrepareForExport<T> = (selection: T[]) => ExportFilter[]
export type PrepareForExport<T> = (selection: T[]) => ExportFilter[]
